export default __webpack_public_path__ + "static/media/99_mobile.b58261d7.jpg";